/*
 * df-pdp-main.js — el JavaScript de la ficha de producto (`df-main-product`).
 *
 * `[24-09-2026]` Vivía en un <script> dentro de la sección: 62 KB (la mitad,
 * comentarios) que se descargaban en CADA visita a una ficha y no se podían
 * guardar en caché. Aquí se descargan una vez. Lo único que dependía de
 * Liquid eran cuatro valores, que ahora deja la sección en `window.__dfPdp`
 * justo antes de cargar este fichero: `sid` (id de la sección), `handle`,
 * `currency` y `product` (el JSON del producto).
 *
 * Se carga con `defer`: corre al acabar de leer el HTML, y la propia función
 * de arranque sigue esperando al primer pintado como antes.
 */
  (function () {
    /*
     * Diferir la ejecución del JS del PDP hasta DESPUÉS del primer paint.
     * Antes: este script (18 KB) era síncrono y bloqueaba DOMContentLoaded,
     * retrasando todos los defer-scripts del <head> y haciendo que las apps
     * (teeinblue customizer, etc.) y el right column tardaran en aparecer.
     *
     * Ahora: el script se ejecuta tras requestAnimationFrame, dando tiempo
     * al browser a pintar el HTML completo antes de procesar la lógica JS.
     */
    function _initPDP() {
    var CFG = window.__dfPdp || {};
    var sec = document.getElementById('df-pdp-' + CFG.sid);
    if (!sec) return;

    // === RECENTLY VIEWED tracking ===
    try {
      var KEY = 'df:recent';
      var handle = CFG.handle || '';
      if (handle) {
        var raw = localStorage.getItem(KEY) || '';
        var list = raw ? raw.split(',').filter(Boolean) : [];
        // Move current to front, dedupe, cap at 12
        list = [handle].concat(list.filter(function (h) { return h !== handle; })).slice(0, 12);
        localStorage.setItem(KEY, list.join(','));
      }
    } catch (e) {}

    // === CARGA DE LAS FOTOS (26-09) =======================================
    // «Al clicar en la galería tarda mucho en cargar cada imagen». Todas las
    // fotos menos la primera son `lazy`: el navegador no pide ninguna hasta
    // que asoma, así que cada clic esperaba una descarga entera desde cero.
    // En el móvil, además, el carrusel se desplazaba pasando por todas las
    // fotos de en medio y el navegador las bajaba todas antes que la pedida.
    // Medido con 4G en Donde nos Conocimos: de la foto 8 a la 12, 1,9 s y
    // 942 KB, cuatro de las cinco fotos sin que nadie las hubiera pedido.
    //
    // Estas piezas las usan la galería y el visor:
    // - `pedir`: pasar una foto a `eager` hace que el navegador la baje ya,
    //   aunque no se vea (o aunque el visor siga oculto).
    // - `marcador`: mientras llega, la mejor versión de esa foto que ya está
    //   en caché (la miniatura, la del escenario) de fondo, en vez de un
    //   hueco. Se quita al llegar: con un PNG transparente se vería detrás.
    // - `entrar`: el fundido de un salto largo, que ya no se desplaza.
    function pedir(img) {
      if (img && img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
    }
    function mejorCargada(imgs) {
      var mejor = '', ancho = 0;
      imgs.forEach(function (im) {
        if (!im || !im.complete || !im.naturalWidth || !im.currentSrc) return;
        var w = Number((/[?&]width=(\d+)/.exec(im.currentSrc) || [])[1]) || 99999;
        if (w > ancho) { ancho = w; mejor = im.currentSrc; }
      });
      return mejor;
    }
    function marcador(caja, img, fuentes) {
      if (!caja || !img || caja.style.backgroundImage || (img.complete && img.naturalWidth)) return;
      var src = mejorCargada(fuentes);
      if (!src) return;
      caja.style.backgroundImage = 'url("' + src + '")';
      caja.style.backgroundSize = 'cover';
      caja.style.backgroundPosition = 'center';
      caja.style.backgroundRepeat = 'no-repeat';
      var quitar = function () {
        caja.style.backgroundImage = '';
        caja.style.backgroundSize = '';
        caja.style.backgroundPosition = '';
        caja.style.backgroundRepeat = '';
      };
      img.addEventListener('load', quitar, { once: true });
      img.addEventListener('error', quitar, { once: true });
    }
    function entrar(n) {
      if (!n) return;
      n.classList.remove('is-entra');
      void n.offsetWidth;
      n.classList.add('is-entra');
    }
    // Lo que va detrás de una foto (sus vecinas) espera a que llegue: pedidas
    // a la vez se repartían la conexión con ella y la retrasaban.
    function despues(img, fn) {
      if (!img || (img.complete && img.naturalWidth)) { fn(); return; }
      img.addEventListener('load', fn, { once: true });
      img.addEventListener('error', fn, { once: true });
    }
    function trasCargar(fn) {
      if (document.readyState === 'complete') fn();
      else window.addEventListener('load', fn, { once: true });
    }
    // Las URL de Shopify llevan el ancho en `width=`: de una se sacan todas.
    function urlAncho(u, w) { return String(u).replace(/([?&]width=)\d+/, '$1' + w); }
    function srcsetDe(u, anchos) {
      return anchos.map(function (w) { return urlAncho(u, w) + ' ' + w + 'w'; }).join(', ');
    }

    // === GALERÍA ==========================================================
    // El escenario dejó de ser un montón de capas en cross-fade y pasó a ser
    // un carrusel con scroll nativo: el dedo arrastra, el trackpad desplaza
    // y el navegador pone el momentum. El JS solo escucha dónde ha parado el
    // scroll y pinta el estado; si no llegara, la primera foto sigue ahí y
    // el gesto sigue funcionando, porque lo hace el navegador.
    var stage = sec.querySelector('[data-df-media-stage]');
    var rail = sec.querySelector('[data-df-thumbs]');
    var thumbs = Array.prototype.slice.call(sec.querySelectorAll('[data-df-thumb]'));
    var slides = stage ? Array.prototype.slice.call(stage.querySelectorAll('[data-df-media-index]')) : [];
    var lens = sec.querySelector('[data-df-lens]');
    var barra = sec.querySelector('[data-df-progress]');
    var gal = sec.querySelector('[data-df-gallery]');
    var ratonFino = window.matchMedia('(hover: hover) and (pointer: fine)');
    var menosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)');
    var pos = 0;

    if (stage && slides.length) {
      function fuenteZoom(i) {
        var s = slides[i];
        return s ? s.getAttribute('data-df-zoom') : null;
      }

      // Centra la miniatura activa en su propia caja. `scrollIntoView` movía
      // también la página, y en móvil el rail está justo bajo el escenario:
      // saltaba la vista entera al cambiar de foto.
      function verMiniatura(i) {
        var t = thumbs[i];
        if (!rail || !t) return;
        if (rail.scrollWidth > rail.clientWidth + 2) {
          rail.scrollTo({ left: t.offsetLeft - (rail.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
        } else if (rail.scrollHeight > rail.clientHeight + 2) {
          rail.scrollTo({ top: t.offsetTop - (rail.clientHeight - t.offsetHeight) / 2, behavior: 'smooth' });
        }
      }

      function fotoDe(i) { return slides[i] ? slides[i].querySelector('img') : null; }
      function miniDe(i) { return thumbs[i] ? thumbs[i].querySelector('img') : null; }

      // La foto i, pedida ya y con su miniatura de fondo mientras llega.
      function preparar(i) {
        var im = fotoDe(i);
        if (!im) return;
        pedir(im);
        marcador(slides[i], im, [miniDe(i)]);
      }
      // Las de al lado, para que deslizar o darle a la flecha no espere, en
      // cuanto ha llegado la que se ve. Solo con el escenario a la vista: con
      // Teeinblue al mando no se ve y serían descargas para nadie.
      function vecinas(i) {
        if (!stage.offsetWidth) return;
        despues(fotoDe(i), function () {
          if (pos !== i) return;
          preparar(i + 1);
          preparar(i - 1);
        });
      }

      // La lupa es la foto a 2200 px. Se pedía en cada cambio de foto, también
      // en el móvil, que no tiene ratón con el que usarla: hasta 430 KB por
      // foto que nadie iba a ver, compitiendo con la que sí. Ahora solo con
      // ratón, y cuando la foto del escenario ya ha llegado.
      function lupaDe(i) {
        var src = fuenteZoom(i);
        lens.style.backgroundImage = '';
        if (!src || !ratonFino.matches) return;
        var im = fotoDe(i);
        var poner = function () { if (pos === i) lens.style.backgroundImage = 'url("' + src + '")'; };
        trasCargar(function () {
          if (!im || (im.complete && im.naturalWidth)) poner();
          else im.addEventListener('load', poner, { once: true });
        });
      }

      function pintar(i) {
        pos = i;
        slides.forEach(function (n, k) { n.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (t, k) {
          t.classList.toggle('is-active', k === i);
          t.setAttribute('aria-current', k === i ? 'true' : 'false');
        });
        if (barra) barra.style.setProperty('--df-pos', String(i));
        sec.querySelectorAll('[data-df-nav]').forEach(function (b) {
          var d = Number(b.getAttribute('data-df-nav'));
          b.disabled = (d < 0 && i === 0) || (d > 0 && i === slides.length - 1);
        });
        if (gal) gal.classList.toggle('is-zoomable', !!fuenteZoom(i));
        if (lens) lupaDe(i);
        verMiniatura(i);
      }

      // Lo que avanza el carrusel por foto. Era el ancho del escenario, y en
      // escritorio lo sigue siendo; en móvil hay 8px de aire entre fotos, así
      // que se mide de verdad.
      function paso() {
        return slides.length > 1
          ? (slides[1].offsetLeft - slides[0].offsetLeft) || stage.clientWidth
          : stage.clientWidth;
      }

      // Un paso (flecha, miniatura de al lado) se desplaza con suavidad. Un
      // salto va directo, con un fundido corto: pasar por las fotos de en
      // medio hacía que el navegador las bajara todas antes que esta.
      function irA(i, suave) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        var desde = pos;
        var directo = suave === false || menosMovimiento.matches || Math.abs(i - desde) > 1;
        preparar(i);
        if (suave !== false && directo && !menosMovimiento.matches) entrar(slides[i]);
        stage.scrollTo({ left: i * paso(), behavior: directo ? 'auto' : 'smooth' });
        pintar(i);
        // Las vecinas, solo si la galería se ha movido: al arrancar, la
        // sincronía con la variante llama aquí con la foto que ya se ve, y
        // las pedía en escritorio y antes de acabar de cargar la página.
        if (suave !== false && i !== desde) vecinas(i);
      }

      // El scroll manda: quien mueve el índice es dónde ha parado el dedo.
      var pendiente = 0;
      stage.addEventListener('scroll', function () {
        if (pendiente) return;
        pendiente = requestAnimationFrame(function () {
          pendiente = 0;
          if (!stage.clientWidth) return;
          var i = Math.round(stage.scrollLeft / paso());
          if (i !== pos && slides[i]) { pintar(i); vecinas(i); }
        });
      }, { passive: true });
      // Al poner el dedo ya se sabe que va a deslizar: las vecinas, ya. Con
      // ratón no, que el clic abre el visor.
      stage.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') vecinas(pos);
      }, { passive: true });

      // Al cambiar el ancho, el scroll se queda a medio camino entre dos fotos.
      var reajuste = 0;
      window.addEventListener('resize', function () {
        clearTimeout(reajuste);
        reajuste = setTimeout(function () { irA(pos, false); }, 150);
      });

      thumbs.forEach(function (t) {
        var i = Number(t.getAttribute('data-df-thumb'));
        // Con el ratón encima, su foto se empieza a pedir unos cientos de ms
        // antes del clic. Tras 120 ms parado, para no pedir todas las que
        // cruza de camino a otra cosa.
        var intencion = 0;
        t.addEventListener('pointerenter', function (e) {
          if (e.pointerType === 'mouse') intencion = setTimeout(function () { preparar(i); }, 120);
        });
        t.addEventListener('pointerleave', function () { clearTimeout(intencion); });
        t.addEventListener('focus', function () { preparar(i); });
        // En escritorio y en móvil, la miniatura cambia la foto. (Hasta el
        // 27-09 en escritorio era un mosaico y abría el visor.)
        t.addEventListener('click', function () { irA(i); });
      });

      // Flechas de la columna de miniaturas (escritorio, en vertical a la
      // izquierda de la foto): solo si hay más por ese lado, y cada clic pasa
      // una tanda de cuatro. Miden el eje que desborda, por si la tira vuelve
      // a ir en horizontal.
      var tiraNav = Array.prototype.slice.call(sec.querySelectorAll('[data-df-thumbs-nav]'));
      if (rail && tiraNav.length) {
        var enVertical = function () {
          return rail.scrollHeight - rail.clientHeight > rail.scrollWidth - rail.clientWidth;
        };
        var flechasTira = function () {
          var v = enVertical();
          var max = v ? rail.scrollHeight - rail.clientHeight : rail.scrollWidth - rail.clientWidth;
          var ya = v ? rail.scrollTop : rail.scrollLeft;
          tiraNav.forEach(function (b) {
            var d = Number(b.getAttribute('data-df-thumbs-nav'));
            b.hidden = max <= 2 || (d < 0 ? ya <= 2 : ya >= max - 2);
          });
        };
        tiraNav.forEach(function (b) {
          var d = Number(b.getAttribute('data-df-thumbs-nav'));
          b.addEventListener('click', function () {
            var v = enVertical();
            var t0 = thumbs[0];
            var tanda = t0 ? ((v ? t0.offsetHeight : t0.offsetWidth) + 10) * 4 : (v ? rail.clientHeight : rail.clientWidth) * 0.8;
            var modo = menosMovimiento.matches ? 'auto' : 'smooth';
            rail.scrollBy(v ? { top: d * tanda, behavior: modo } : { left: d * tanda, behavior: modo });
          });
        });
        var tiraPend = 0;
        rail.addEventListener('scroll', function () {
          if (tiraPend) return;
          tiraPend = requestAnimationFrame(function () { tiraPend = 0; flechasTira(); });
        }, { passive: true });
        // La tira nace oculta en los productos que esperan a Teeinblue y
        // aparece cuando llega el personalizador de brandeate: sin nada que
        // mida, las flechas se quedaban calculadas con la tira a 0 px.
        if (window.ResizeObserver) new ResizeObserver(flechasTira).observe(rail);
        window.addEventListener('resize', flechasTira);
        trasCargar(flechasTira);
        flechasTira();
      }
      sec.querySelectorAll('[data-df-nav]').forEach(function (b) {
        var d = Number(b.getAttribute('data-df-nav'));
        // Igual con las flechas: el ratón llega antes que el clic.
        b.addEventListener('pointerenter', function () { preparar(pos + d); });
        b.addEventListener('click', function () { irA(pos + d); });
      });

      // Con la página ya cargada, la segunda foto: deslizar (o la primera
      // miniatura) es lo primero que se hace en una ficha y salía en blanco.
      // Solo con la galería nuestra; si Teeinblue aún puede quedársela, se
      // espera a saberlo.
      var galeria = stage.closest('.df-pdp__gallery');
      var esNuestra = function () {
        return !galeria.classList.contains('tee-gallery-wrapper') &&
          (!galeria.classList.contains('df-pdp__gallery--tee') ||
            galeria.classList.contains('df-pdp__gallery--tee-fallo'));
      };
      if (galeria && slides.length > 1) {
        trasCargar(function () {
          setTimeout(function () {
            if (esNuestra()) { vecinas(pos); return; }
            var espera = new MutationObserver(function () {
              if (galeria.classList.contains('tee-gallery-wrapper')) espera.disconnect();
              else if (esNuestra()) { espera.disconnect(); vecinas(pos); }
            });
            espera.observe(galeria, { attributes: true, attributeFilter: ['class'] });
          }, 300);
        });
      }

      if (gal) {
        gal.setAttribute('tabindex', '0');
        gal.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); irA(pos + 1); }
          if (e.key === 'ArrowLeft')  { e.preventDefault(); irA(pos - 1); }
        });
      }

      // ---- Lupa. Solo ratón: en táctil no hay cursor al que seguir. -------
      if (lens && gal) {
        var lupa = false;
        gal.addEventListener('pointerenter', function (e) {
          if (e.pointerType !== 'mouse' || !ratonFino.matches || !fuenteZoom(pos)) return;
          lupa = true;
          // Si la foto del escenario aún no había llegado, la lupa no estaba
          // pedida: el ratón ya está encima, así que ahora.
          if (!lens.style.backgroundImage) lens.style.backgroundImage = 'url("' + fuenteZoom(pos) + '")';
          gal.classList.add('is-zooming');
        });
        gal.addEventListener('pointerleave', function () {
          lupa = false;
          gal.classList.remove('is-zooming');
        });
        gal.addEventListener('pointermove', function (e) {
          if (!lupa) return;
          var r = gal.getBoundingClientRect();
          if (!r.width || !r.height) return;
          var x = ((e.clientX - r.left) / r.width) * 100;
          var y = ((e.clientY - r.top) / r.height) * 100;
          lens.style.backgroundPosition = x.toFixed(2) + '% ' + y.toFixed(2) + '%';
        });
      }

      pintar(0);
      // Otros bloques (la sincronía con la variante) mueven la galería por aquí.
      // Fotos de variante (27-09): la galería solo lleva la de la variante
      // marcada, en el primer hueco (ver `df_filtrado` en la sección). Al
      // cambiar de variante se pone ahí la de la nueva: escenario, miniatura
      // y visor. La foto vieja sigue a la vista hasta que llega la nueva.
      var fotosVariante = CFG.fotosVariante || {};
      function fotoVariante(id) {
        var f = fotosVariante[id];
        if (!f || !slides[0]) return false;
        var im = fotoDe(0), mi = miniDe(0);
        slides[0].setAttribute('data-df-media-id', String(id));
        slides[0].setAttribute('data-df-zoom', urlAncho(f.u, 2200));
        if (im) {
          im.srcset = srcsetDe(f.u, [600, 900, 1200, 1400, 1600]);
          im.src = f.u;
          im.alt = f.a;
        }
        if (mi) {
          mi.srcset = srcsetDe(f.u, [120, 240, 360, 480, 640, 800]);
          mi.src = urlAncho(f.u, 800);
        }
        if (sec.__dfVisor && sec.__dfVisor.primera) sec.__dfVisor.primera(f);
        return true;
      }
      sec.__dfGaleria = { irA: irA, donde: function () { return pos; }, fotoVariante: fotoVariante };
    }

    // === VISOR A PANTALLA COMPLETA =========================================
    (function () {
      var visor = sec.querySelector('[data-df-viewer]');
      if (!visor) return;
      // `.df-pdp` lleva `overflow-x: hidden` en móvil; un fixed de dentro se
      // acaba peleando con él. Fuera, al body, y se acabó.
      document.body.appendChild(visor);

      var pista = visor.querySelector('[data-df-viewer-track]');
      var laminas = Array.prototype.slice.call(visor.querySelectorAll('[data-df-viewer-index]'));
      var vCuenta = visor.querySelector('[data-df-viewer-current]');
      var vMinis = Array.prototype.slice.call(visor.querySelectorAll('[data-df-viewer-thumb]'));
      var abierto = false;
      var vPos = 0;
      var focoPrevio = null;
      if (!pista || !laminas.length) return;

      function vFoto(i) { return laminas[i] ? laminas[i].querySelector('img') : null; }
      function miniPagina(i) { return thumbs[i] ? thumbs[i].querySelector('img') : null; }

      // La foto i del visor, pedida ya. Mientras llega, de fondo la mejor que
      // ya haya en la ficha: la del escenario o la del mosaico. En el móvil
      // el visor pide la misma URL que el escenario (ver su `sizes` en la
      // sección), así que lo normal es que ni haga falta.
      function vPedir(i) {
        var im = vFoto(i);
        if (!im) return;
        // Con `is-pedida` la foto tiene caja antes de llegar (ver el CSS).
        laminas[i].classList.add('is-pedida');
        pedir(im);
        marcador(im, im, [slides[i] ? slides[i].querySelector('img') : null, miniPagina(i)]);
      }

      // La tira del visor son las mismas fotos que la de la ficha, que ya
      // están en caché: se reutilizan en vez de pedir otras dieciséis justo
      // mientras baja la grande. Las que la ficha aún no tenía piden la suya.
      function reusarMiniaturas() {
        vMinis.forEach(function (b, k) {
          var im = b.querySelector('img');
          var ya = miniPagina(k);
          if (!im || !ya || (im.complete && im.naturalWidth) || !ya.complete || !ya.naturalWidth) return;
          im.removeAttribute('srcset');
          im.removeAttribute('sizes');
          im.src = ya.currentSrc;
        });
      }

      // Ampliada (x2,2) la foto se ve a más del doble de lo que se pidió: se
      // pide la de 2200 px —la misma URL que la lupa, que igual ya está en
      // caché— y se cambia cuando ha llegado, para que no parpadee. Con
      // `sizes` de 4000px el navegador elige la más grande del `srcset`.
      function nitida(i) {
        var im = vFoto(i);
        var url = slides[i] ? slides[i].getAttribute('data-df-zoom') : '';
        if (!im || !url || im.getAttribute('sizes') === '4000px') return;
        var pre = new Image();
        pre.onload = function () { im.setAttribute('sizes', '4000px'); };
        pre.src = url;
      }

      function vPintar(i) {
        vPos = i;
        if (vCuenta) vCuenta.textContent = String(i + 1);
        vMinis.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        visor.querySelectorAll('[data-df-viewer-nav]').forEach(function (b) {
          var d = Number(b.getAttribute('data-df-viewer-nav'));
          b.disabled = (d < 0 && i === 0) || (d > 0 && i === laminas.length - 1);
        });
        laminas.forEach(function (s) {
          s.classList.remove('is-zoom');
          var im = s.querySelector('img');
          if (im) im.style.transformOrigin = '';
        });
        // La que se ve, por si se ha llegado deslizando más rápido que las
        // vecinas; y las de al lado, cuando haya llegado esta.
        vPedir(i);
        despues(vFoto(i), function () {
          if (!abierto || vPos !== i) return;
          vPedir(i + 1);
          vPedir(i - 1);
        });
      }

      // Como en el escenario: un paso se desplaza, un salto va directo.
      function vIrA(i, suave) {
        i = Math.max(0, Math.min(laminas.length - 1, i));
        var directo = suave === false || menosMovimiento.matches || Math.abs(i - vPos) > 1;
        vPedir(i);
        if (suave !== false && directo && !menosMovimiento.matches) entrar(laminas[i]);
        pista.scrollTo({ left: i * pista.clientWidth, behavior: directo ? 'auto' : 'smooth' });
        vPintar(i);
      }

      var vPend = 0;
      pista.addEventListener('scroll', function () {
        if (vPend) return;
        vPend = requestAnimationFrame(function () {
          vPend = 0;
          if (!pista.clientWidth) return;
          var i = Math.round(pista.scrollLeft / pista.clientWidth);
          if (i !== vPos && laminas[i]) vPintar(i);
        });
      }, { passive: true });

      function abrir(i) {
        if (abierto) return;
        abierto = true;
        focoPrevio = document.activeElement;
        vPedir(i);
        reusarMiniaturas();
        visor.hidden = false;
        document.body.style.overflow = 'hidden';
        // Todo síncrono. Estaba dentro de un `requestAnimationFrame` y en una
        // pestaña que no repinta el rAF no llega: el visor se quedaba abierto
        // y transparente, tapando la página sin verse. La animación de
        // entrada la lleva el CSS, que ya es a prueba de eso.
        visor.classList.add('is-open');
        pista.scrollLeft = i * pista.clientWidth;
        vPintar(i);
        var c = visor.querySelector('[data-df-viewer-close]');
        if (c && c.focus) c.focus();
      }

      function cerrar() {
        if (!abierto) return;
        abierto = false;
        visor.classList.remove('is-open');
        visor.hidden = true;
        document.body.style.overflow = '';
        // El escenario NO se mueve al cerrar. Arrastraba la foto que estabas
        // mirando hasta arriba, y en escritorio esa foto sigue estando en el
        // mosaico: la misma imagen salia dos veces en pantalla. El visor
        // ensena una foto y se va; la ficha se queda como la dejaste.
        if (focoPrevio && focoPrevio.focus) focoPrevio.focus();
      }

      // La primera lámina, con la foto de la variante nueva (ver
      // `fotoVariante` en la galería). El `sizes` depende de la proporción.
      function primera(f) {
        var im = vFoto(0);
        var mi = vMinis[0] ? vMinis[0].querySelector('img') : null;
        var ar = f.w / f.h;
        if (laminas[0]) laminas[0].style.setProperty('--df-ar', String(ar));
        if (im) {
          im.setAttribute('sizes', '(min-aspect-ratio: ' + f.w + '/' + f.h + ') calc((100vh - ' +
            (laminas.length > 1 ? '156px' : '72px') + ') * ' + ar + '), 100vw');
          im.srcset = srcsetDe(f.u, [600, 900, 1200, 1400, 1600, 2200]);
          im.src = urlAncho(f.u, 2200);
          im.alt = f.a;
        }
        if (mi) {
          mi.removeAttribute('srcset');
          mi.removeAttribute('sizes');
          mi.src = urlAncho(f.u, 200);
        }
      }

      sec.__dfVisor = { abrir: abrir, primera: primera };

      // Click en la foto del escenario: el mismo gesto de siempre en una
      // ficha de producto. La lupa no lo intercepta (pointer-events: none).
      //
      // Con guardia de arrastre, como el carrusel de vídeos: al deslizar con
      // el dedo el navegador remata el gesto con un `click`, y sin esto cada
      // swipe abría el visor a pantalla completa.
      if (stage) {
        var ax = 0, ay = 0, arrastre = false;
        function empiezaGesto(x, y) { ax = x; ay = y; arrastre = false; }
        function mueveGesto(x, y) {
          if (Math.abs(x - ax) > 10 || Math.abs(y - ay) > 10) arrastre = true;
        }
        stage.addEventListener('pointerdown', function (e) { empiezaGesto(e.clientX, e.clientY); });
        stage.addEventListener('pointermove', function (e) { mueveGesto(e.clientX, e.clientY); });
        stage.addEventListener('touchstart', function (e) {
          var p = e.touches[0]; if (p) empiezaGesto(p.clientX, p.clientY);
        }, { passive: true });
        stage.addEventListener('touchmove', function (e) {
          var p = e.touches[0]; if (p) mueveGesto(p.clientX, p.clientY);
        }, { passive: true });
        stage.addEventListener('click', function (e) {
          if (arrastre) return;
          if (e.target.closest('a, button, video, iframe, model-viewer')) return;
          abrir(sec.__dfGaleria ? sec.__dfGaleria.donde() : 0);
        });
      }

      visor.querySelectorAll('[data-df-viewer-close]').forEach(function (b) {
        b.addEventListener('click', cerrar);
      });
      visor.querySelectorAll('[data-df-viewer-nav]').forEach(function (b) {
        b.addEventListener('click', function () { vIrA(vPos + Number(b.getAttribute('data-df-viewer-nav'))); });
      });
      vMinis.forEach(function (t) {
        t.addEventListener('click', function () { vIrA(Number(t.getAttribute('data-df-viewer-thumb'))); });
      });

      // Click en la imagen: 2,2x sobre el punto donde has pinchado. Click
      // fuera de la imagen, dentro de la lámina: cerrar.
      laminas.forEach(function (s, k) {
        var im = s.querySelector('img');
        s.addEventListener('click', function (e) {
          if (e.target !== im) { cerrar(); return; }
          if (!ratonFino.matches) return;
          var r = im.getBoundingClientRect();
          if (s.classList.toggle('is-zoom')) {
            im.style.transformOrigin =
              (((e.clientX - r.left) / r.width) * 100).toFixed(2) + '% ' +
              (((e.clientY - r.top) / r.height) * 100).toFixed(2) + '%';
            nitida(k);
          } else {
            im.style.transformOrigin = '';
          }
        });
      });

      document.addEventListener('keydown', function (e) {
        if (!abierto) return;
        if (e.key === 'Escape') { e.preventDefault(); cerrar(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); vIrA(vPos + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); vIrA(vPos - 1); }
        else if (e.key === 'Tab') {
          // Trampa de foco sencilla: mientras el visor tapa la página, el
          // tabulador no puede escaparse a lo que hay debajo.
          var focos = visor.querySelectorAll('button:not([disabled])');
          if (!focos.length) return;
          var primero = focos[0], ultimo = focos[focos.length - 1];
          if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
          else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
        }
      });
    })();

    // === CUSTOMIZER mock state (steps activation) ===
    sec.querySelectorAll('[data-df-customizer-step]').forEach(function (step) {
      step.querySelectorAll('[data-df-customizer-value]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var siblings = step.querySelectorAll('[data-df-customizer-value]');
          siblings.forEach(function (s) { s.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });
    });

    // === CTA pegado abajo: solo por debajo del botón ==============
    // Se compara la posición NATURAL de la fila con el scroll. Nada de
    // centinelas: la columna de la ficha reordena sus hijos con `order` en
    // móvil, así que un elemento insertado antes de la fila en el HTML acaba
    // pintado en otro sitio —arriba del todo— y disparaba la barra con el
    // botón todavía a la vista, 700px más abajo.
    //
    // El hueco mantiene la altura al sacar la fila del flujo, así que la
    // posición natural no se mueve mientras está fija.
    (function () {
      var fila = sec.querySelector('.df-pdp__cta-row--mobile-sticky');
      if (!fila) return;

      var hueco = document.createElement('div');
      hueco.setAttribute('aria-hidden', 'true');
      hueco.style.cssText = 'display:block;height:0;margin:0;padding:0';
      fila.parentNode.insertBefore(hueco, fila.nextSibling);

      var topNatural = 0, alto = 0;

      function medir() {
        // En estado fijo el rect ya no dice dónde vive la fila: se conserva
        // la última medida buena.
        if (fila.classList.contains('is-stuck')) return;
        var r = fila.getBoundingClientRect();
        topNatural = r.top + window.scrollY;
        alto = r.height;
      }

      function fijar(si) {
        if (si === fila.classList.contains('is-stuck')) return;
        if (si) {
          hueco.style.height = alto + 'px';
          fila.classList.add('is-stuck');
        } else {
          fila.classList.remove('is-stuck');
          hueco.style.height = '0';
        }
      }

      var pendiente = false;
      function revisar() {
        pendiente = false;
        medir();
        // Pegada solo cuando la fila entera ha salido por arriba.
        fijar(window.scrollY > topNatural + alto);
      }
      function alScroll() {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(revisar);
      }
      window.addEventListener('scroll', alScroll, { passive: true });
      window.addEventListener('resize', alScroll);
      /* La ficha crece después de cargar —el personalizador de Teeinblue se
         monta tarde y empuja la fila hacia abajo—. Sin volver a medir, la
         barra se quedaba fija con el botón ya a la vista. */
      window.addEventListener('load', alScroll);
      if ('ResizeObserver' in window) {
        new ResizeObserver(alScroll).observe(document.body);
      }
      /* Al llegar al pie la barra se retira (24-09): tapaba el «−10 % si
         entras al club» del pie. Y como allí ya no está, el final de la
         página no necesita el margen que le reservaba el body. */
      var pie = document.querySelector('.footer-sections');
      if (pie && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          fila.classList.toggle('is-pie', es[es.length - 1].isIntersecting);
        }).observe(pie);
      }
      revisar();
    })();

    // === DELIVERY DATE (intenso, countdown vivo) ===
    var del = sec.querySelector('[data-df-delivery]');
    if (del) {
      var etaEl = del.querySelector('[data-df-delivery-eta]');
      var timerEl = del.querySelector('[data-df-delivery-timer]');
      var timerEl2 = del.querySelector('[data-df-delivery-timer-2]');
      var countdownLine = del.querySelector('.df-pdp__delivery-countdown-line');
      var countdownPill = del.querySelector('[data-df-delivery-countdown]');
      // Toggle "Si pides hoy" vs "Si pides en {timer}" (h>12 → hoy)
      var pdpTimerWrap = del.querySelector('[data-df-pdp-countdown-timer]');
      var pdpTodayWrap = del.querySelector('[data-df-pdp-countdown-today]');
      var cutoff = Number(del.getAttribute('data-cutoff-hour')) || 14;
      /* La unión entre las dos fechas llega SIN los espacios de los lados
         —el ajuste del editor vale «o el»—, así que unir tal cual escribía
         «mié 30o eljue 1». Se ponen aquí en vez de fiarlo a que quien escriba
         el ajuste se acuerde de dejar un espacio invisible a cada lado. Vacío
         sigue siendo « y », como antes. */
      var etaJoin = (del.getAttribute('data-eta-join') || '').trim();
      etaJoin = etaJoin ? ' ' + etaJoin + ' ' : ' y ';
      var diasMin = Number(del.getAttribute('data-days-min')) || 1;
      var diasMax = Number(del.getAttribute('data-days-max')) || 2;
      /* Festivos, no solo fines de semana: el 25 de diciembre no se produce ni
         se reparte, y contarlo como laborable prometía una fecha imposible en
         la semana en la que más se compra. La lista vive en los ajustes del
         tema para poder añadir los de la comunidad y los del taller. */
      var festivos = (del.getAttribute('data-festivos') || '')
        .split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      function esLaborable(dt) {
        var wd = dt.getDay();
        if (wd === 0 || wd === 6) return false;
        var m = dt.getMonth() + 1, d2 = dt.getDate();
        var iso = dt.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (d2 < 10 ? '0' + d2 : d2);
        return festivos.indexOf(iso) === -1;
      }
      function addBusiness(d, days) {
        var dt = new Date(d), c = 0;
        while (c < days) { dt.setDate(dt.getDate() + 1); if (esLaborable(dt)) c++; }
        return dt;
      }
      /* El día que SALE el pedido, que es de donde cuentan los 1-2 laborables.
         Antes se contaba desde el momento del pedido y por eso un sábado por
         la tarde salían cuatro días: el finde no produce nada, así que el
         reloj no empieza hasta el lunes. Sale hoy si hoy se trabaja y aún no
         ha pasado el corte; si no, el primer laborable siguiente. */
      function diaSalida(now) {
        var dt = new Date(now);
        if (esLaborable(dt) && dt.getHours() < cutoff) return dt;
        do { dt.setDate(dt.getDate() + 1); } while (!esLaborable(dt));
        return dt;
      }
      // Tres letras: «mar», «mié». Con el día entero —«martes 25 o el
      // miércoles 26»— la caja se iba a tres líneas y el subtítulo quedaba
      // colgando; la fecha se lee igual de bien abreviada.
      /* El idioma sale del <html lang>: en /pt-pt/ el día corto lo da Intl
         en pt-PT («qui», «sex») y las palabras sueltas, esta tabla. */
      var DFP_PT = (document.documentElement.getAttribute('lang') || 'es').toLowerCase().indexOf('pt') === 0;
      var DFP_LOC = DFP_PT ? 'pt-PT' : 'es-ES';
      var DFP_T = DFP_PT
        ? { hoy: 'hoje', manana: 'amanhã', el: 'na ', ahora: 'agora' }
        : { hoy: 'hoy', manana: 'mañana', el: 'el ', ahora: 'ahora' };
      function wd3(d) {
        return d.toLocaleString(DFP_LOC, { weekday: 'short' }).replace('.', '');
      }
      function update() {
        var now = new Date();
        var salida = diaSalida(now);
        var fMin = addBusiness(salida, diasMin), fMax = addBusiness(salida, diasMax);
        var wdMin = wd3(fMin);
        var wdMax = wd3(fMax);
        var eta = wdMin + ' ' + fMin.getDate();
        // Si las dos fechas caen el mismo día no hay nada que unir.
        if (fMin.toDateString() !== fMax.toDateString()) {
          eta += etaJoin + wdMax + ' ' + fMax.getDate();
        }
        /* Se vuelve a buscar el nodo en cada pasada en vez de guardarlo al
           arrancar: el personalizador rehace esta zona del DOM y el nodo
           original se quedaba huérfano —seguíamos escribiendo la fecha en un
           elemento que ya no estaba en la página. */
        var etaVivo = document.querySelector('[data-df-delivery-eta]') || etaEl;
        if (etaVivo) etaVivo.textContent = eta;

        /* La cuenta atrás va al corte del día de salida, que es lo único que
           el cliente puede perder. Un sábado por la tarde apuntaba al domingo
           a las 14:00, un corte que no existe. */
        var target = new Date(salida);
        target.setHours(cutoff, 0, 0, 0);
        var msTo = target - now;
        var h = Math.max(0, Math.floor(msTo / 3600000));
        var m = Math.max(0, Math.floor((msTo % 3600000) / 60000));
        var s = Math.max(0, Math.floor((msTo % 60000) / 1000));
        var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
        var timerStr = pad(h) + 'h ' + pad(m) + 'm';
        /* Con más de un día por delante, 42h no se lee como una cuenta atrás.
           Se parte en días y horas y el reloj sigue corriendo: la urgencia es
           real —pasado el corte se pierde un día de verdad—, solo hay que
           decirla en unidades que se entiendan de un vistazo. */
        var timerStrLong;
        if (h >= 24) {
          timerStrLong = Math.floor(h / 24) + 'd ' + pad(h % 24) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
        } else {
          timerStrLong = pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
        }
        /* «hoy» / «mañana» / «el lun»: un día de la semana suelto obliga al
           cliente a mirar el calendario para saber si eso es pronto. */
        var manana = new Date(now); manana.setDate(manana.getDate() + 1);
        var diaTxt;
        if (salida.toDateString() === now.toDateString()) diaTxt = DFP_T.hoy;
        else if (salida.toDateString() === manana.toDateString()) diaTxt = DFP_T.manana;
        else diaTxt = DFP_T.el + wd3(salida);
        if (timerEl) timerEl.textContent = timerStr;
        var timerVivo = document.querySelector('[data-df-pdp-countdown-timer]') || pdpTimerWrap;
        if (timerVivo) {
          /* Dos plantillas, y aquí se elige. El reloj sólo se enseña
             mientras el pedido aún puede salir hoy: pasado el corte —o en
             fin de semana— la cuenta atrás apunta al corte de otro día y
             marca «2d 23h», que no dice date prisa, dice que sobra tiempo. */
          var tpl = timerVivo.getAttribute('data-df-tpl') || '';
          var tplUrgente = timerVivo.getAttribute('data-df-tpl-urgente') || '';
          if (diaTxt === DFP_T.hoy && tplUrgente) tpl = tplUrgente;
          var linea = tpl.replace('[dia]', diaTxt);
          /* Esto corre cada segundo. Sin esta comparación se reconstruirían
             los nodos 86.400 veces al día para escribir siempre lo mismo. La
             clave lleva el reloj dentro a propósito: con la línea sin
             sustituir, la urgente se pintaba una vez y se quedaba congelada. */
          var clave = linea.replace('[tiempo]', timerStrLong);
          if (timerVivo.getAttribute('data-df-linea') !== clave) {
            timerVivo.setAttribute('data-df-linea', clave);
            // Con nodos y no con innerHTML: el texto viene de un ajuste del
            // tema y no tiene por qué acabar interpretándose como HTML.
            timerVivo.textContent = '';
            var trozos = linea.split(/(\[ahora\]|\[tiempo\])/);
            for (var ti = 0; ti < trozos.length; ti++) {
              var trozo = trozos[ti];
              if (!trozo) continue;
              if (trozo === '[ahora]' || trozo === '[tiempo]') {
                var fuerte = document.createElement('span');
                fuerte.className = 'df-pdp__deliv-ahora';
                if (trozo === '[tiempo]') fuerte.className += ' df-pdp__deliv-reloj';
                fuerte.textContent = trozo === '[ahora]' ? DFP_T.ahora : timerStrLong;
                timerVivo.appendChild(fuerte);
              } else {
                timerVivo.appendChild(document.createTextNode(trozo));
              }
            }
          }
        }
        // Quitar el estado loading después del primer render real
        if (countdownLine && countdownLine.classList.contains('is-loading')) {
          countdownLine.classList.remove('is-loading');
        }
        // Antes esto miraba `h > 12`, que después del corte daba «Sale hoy
        // mismo» — justo cuando ya NO sale hoy. La regla real es la hora:
        //   00:00 → corte      cuenta atrás para entrar en el envío de hoy
        //   corte → 23:00      ya no entra hoy, pero pedir hoy sigue valiendo
        //   23:00 → 00:00      vuelve la cuenta atrás, hacia el corte de mañana

      }
      update();
      setInterval(update, 1000);
    }

    // === MDAY badge text by days-left ===
    sec.querySelectorAll('[data-df-mday]').forEach(function (b) {
      var parts = b.getAttribute('data-df-mday').split('-');
      var month = Number(parts[0]) - 1, day = Number(parts[1]);
      var now = new Date(), y = now.getFullYear();
      var target = new Date(y, month, day, 23, 59, 59);
      if (now > target) target.setFullYear(y + 1);
      if (now > target) return;
      var daysLeft = Math.ceil((target - now) / 86400000);
      var textEl = b.querySelector('[data-df-mday-text]');
      if (!textEl) return;
      if (daysLeft <= 1) textEl.textContent = 'Hoy es el día';
      else if (daysLeft <= 4) textEl.textContent = 'Últimos días';
      else if (daysLeft <= 10) textEl.textContent = 'Llega a tiempo';
    });

    // === VIDEO GALLERY (metafield) ===
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            if (!v.src && v.dataset.src) v.src = v.dataset.src;
            var poster = v.previousElementSibling;
            if (poster && !poster.classList.contains('df-pdp__video-poster')) poster = null;
            /* El póster aguanta hasta que el vídeo tiene un fotograma que
               enseñar. Antes se ocultaba nada más entrar en pantalla: en una
               conexión lenta, o en el navegador de Instagram —donde el
               autoplay se bloquea aunque vaya en silencio—, lo que quedaba era
               un <video> vacío, es decir un cuadro gris, a veces para siempre. */
            var quitarPoster = function () { if (poster) poster.classList.add('is-hidden'); };
            if (v.readyState >= 2) quitarPoster();
            else v.addEventListener('loadeddata', quitarPoster, { once: true });
            var p = v.play(); if (p && p.catch) p.catch(function(){});
          } else { v.pause(); }
        });
      }, { threshold: 0.5 });
      sec.querySelectorAll('.df-pdp__video[data-src]').forEach(function (v) { vio.observe(v); });
    }

    // === VISOR DE VÍDEOS A PANTALLA COMPLETA ===
    (function () {
      var modal = sec.querySelector('[data-df-story-modal]');
      if (!modal) return;
      var thumbs = Array.prototype.slice.call(sec.querySelectorAll('[data-df-story-open]'));
      var srcs = thumbs.map(function (t) {
        // A pantalla completa, el 720p (`data-src-full`); la tarjeta lleva el 480p.
        var v = t.querySelector('.df-pdp__video');
        return v ? (v.getAttribute('data-src-full') || v.getAttribute('data-src') || v.src) : '';
      }).filter(Boolean);
      if (!srcs.length) return;

      var video = modal.querySelector('[data-df-story-video]');
      var progress = modal.querySelector('[data-df-story-progress]');
      var counter = modal.querySelector('[data-df-story-counter]');
      var muteBtn = modal.querySelector('[data-df-story-mute]');
      var muteIcon = modal.querySelector('[data-df-story-mute-icon]');
      var idx = 0, open = false, raf = 0;

      var ICON_OFF = '<path d="M11 5L6 9H2v6h4l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/>';
      var ICON_ON = '<path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/>';

      // Una barra por vídeo, como en las historias
      srcs.forEach(function () {
        var b = document.createElement('span');
        b.className = 'df-pdp__story-bar';
        b.appendChild(document.createElement('span'));
        progress.appendChild(b);
      });
      var fills = Array.prototype.slice.call(progress.querySelectorAll('span > span'));

      function paint() {
        fills.forEach(function (f, i) {
          f.style.width = i < idx ? '100%' : (i === idx ? '0%' : '0%');
        });
        counter.textContent = (idx + 1) + ' / ' + srcs.length;
      }

      function tick() {
        if (!open) return;
        if (video.duration) {
          fills[idx].style.width = ((video.currentTime / video.duration) * 100) + '%';
        }
        raf = requestAnimationFrame(tick);
      }

      function show(i) {
        // Al llegar al final se cierra: dar la vuelta al carrusel deja al
        // cliente girando en bucle en vez de volver al botón de comprar.
        if (i < 0) { i = 0; }
        if (i >= srcs.length) { close(); return; }
        idx = i;
        video.src = srcs[idx];
        paint();
        var pr = video.play();
        if (pr && pr.catch) pr.catch(function () {});
      }

      function openAt(i) {
        open = true;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        show(i);
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(tick);
      }

      function close() {
        open = false;
        cancelAnimationFrame(raf);
        video.pause();
        video.removeAttribute('src');
        video.load();
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      thumbs.forEach(function (t, i) {
        /* Igual que en la home: el carrusel se desliza con el dedo encima de
           las tarjetas y el navegador remata el gesto con un `click`. Sin este
           guardia, deslizar abría el visor a pantalla completa. */
        var x0 = 0, y0 = 0, t0 = 0, arrastre = false;
        function empieza(x, y) { x0 = x; y0 = y; t0 = Date.now(); arrastre = false; }
        function mueve(x, y) {
          if (Math.abs(x - x0) > 10 || Math.abs(y - y0) > 10) arrastre = true;
        }
        t.addEventListener('pointerdown', function (ev) { empieza(ev.clientX, ev.clientY); });
        t.addEventListener('pointermove', function (ev) { mueve(ev.clientX, ev.clientY); });
        t.addEventListener('touchstart', function (ev) {
          var p = ev.touches[0]; if (p) empieza(p.clientX, p.clientY);
        }, { passive: true });
        t.addEventListener('touchmove', function (ev) {
          var p = ev.touches[0]; if (p) mueve(p.clientX, p.clientY);
        }, { passive: true });
        t.addEventListener('click', function (ev) {
          ev.preventDefault();
          if (arrastre || Date.now() - t0 > 600) return;
          openAt(i);
        });
      });
      modal.querySelectorAll('[data-df-story-close]').forEach(function (b) {
        b.addEventListener('click', close);
      });
      modal.querySelector('[data-df-story-prev]').addEventListener('click', function () { show(idx - 1); });
      modal.querySelector('[data-df-story-next]').addEventListener('click', function () { show(idx + 1); });
      video.addEventListener('ended', function () { show(idx + 1); });

      muteBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        muteBtn.classList.toggle('is-active', !video.muted);
        muteBtn.setAttribute('aria-pressed', String(!video.muted));
        muteBtn.setAttribute('aria-label', video.muted ? 'Activar sonido' : 'Silenciar');
        muteIcon.innerHTML = video.muted ? ICON_OFF : ICON_ON;
      });

      document.addEventListener('keydown', function (ev) {
        if (!open) return;
        if (ev.key === 'Escape') close();
        else if (ev.key === 'ArrowRight') show(idx + 1);
        else if (ev.key === 'ArrowLeft') show(idx - 1);
      });
    })();

    // === VARIANT SELECTION ===
    var form = sec.querySelector('.df-pdp__form');
    var variantInput = sec.querySelector('[data-df-variant-input]');
    var priceEl = sec.querySelector('[data-df-cta-price]');
    var mainPriceWrap = sec.querySelector('[data-df-price]');
    var productJson = CFG.product || { variants: [] };
    var currencyCode = CFG.currency || 'EUR';
    function formatMoney(cents) {
      // Mismo formato que el snippet df-eur: «29,95 €» con espacio DURO.
      // `df-eur` pasó a llevar espacio el 16-09 y esto se quedó pegado:
      // Liquid pintaba «29,95 €», el repintado de la carga lo cambiaba a
      // «29,95€», y la ficha era la única página de la web sin espacio.
      return (Math.round(cents) / 100).toFixed(2).replace('.', ',') + '\u00A0\u20AC';
    }

    // El precio que cambia al elegir otra variante entra con un salto corto,
    // para que se vea que ha cambiado. Solo si cambia: al cargar se repinta
    // con el mismo importe y no tiene que moverse nada.
    function tic(el, txt) {
      if (el.textContent === txt) return;
      el.textContent = txt;
      el.classList.remove('df-pdp-tic');
      void el.offsetWidth;
      el.classList.add('df-pdp-tic');
    }

    function updateSelectedVariant() {
      var selected = [];
      sec.querySelectorAll('[data-df-option]:checked').forEach(function (r) { selected.push(r.value); });
      if (!selected.length) return;
      var v = productJson.variants.find(function (x) {
        return JSON.stringify(x.options) === JSON.stringify(selected);
      });
      if (!v) return;
      if (variantInput) variantInput.value = v.id;

      // === Price update + compare_at handling ===
      if (priceEl) {
        tic(priceEl, formatMoney(v.price));
      }

      // === Precio grande, debajo del título ===
      // OJO: este bloque apuntaba a `.df-price-display__amount` y compañía,
      // clases de la versión anterior del bloque de precio. Al reconstruirlo
      // según el mock pasaron a ser `.df-pdp__price-*` y nadie actualizó el
      // JS: el precio de arriba se quedaba congelado mientras el del botón
      // sí cambiaba. Ahora usa las clases que de verdad existen.
      if (mainPriceWrap) {
        var nowEl = mainPriceWrap.querySelector('.df-pdp__price-now');
        var wasEl = mainPriceWrap.querySelector('.df-pdp__price-was');
        var offEl = mainPriceWrap.querySelector('.df-pdp__price-off');
        var priceRow = mainPriceWrap.querySelector('.df-pdp__price');

        if (nowEl) tic(nowEl, formatMoney(v.price));

        var hasSale = window.DF_SHOW_COMPARE === true && v.compare_at_price && v.compare_at_price > v.price;
        if (hasSale) {
          var pct = Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price);

          if (!wasEl && priceRow) {
            wasEl = document.createElement('s');
            wasEl.className = 'df-pdp__price-was';
            priceRow.appendChild(wasEl);
          }
          if (wasEl) {
            wasEl.textContent = formatMoney(v.compare_at_price);
            wasEl.hidden = false;
          }
          // La pastilla solo se crea si el bloque la tiene activada; si el
          // merchant la apagó, no aparece de la nada al cambiar de variante.
          if (offEl) {
            offEl.textContent = '\u2212' + pct + '%';
            offEl.hidden = false;
          }
        } else {
          if (wasEl) wasEl.hidden = true;
          if (offEl) offEl.hidden = true;
        }
      }

      // === Variant image sync: cambia el media activo a la imagen de la variante ===
      // Marcaba `is-active` a mano. Ahora el escenario es un carrusel con
      // scroll: marcar sin desplazar dejaba el contador en la foto de la
      // variante y la foto, en la anterior.
      if (v.featured_media && v.featured_media.id && sec.__dfGaleria) {
        var newMedia = sec.querySelector('[data-df-media-id="' + v.featured_media.id + '"]');
        if (newMedia) sec.__dfGaleria.irA(Number(newMedia.getAttribute('data-df-media-index')));
        // No está porque es de otra variante: pasa al primer hueco.
        else if (sec.__dfGaleria.fotoVariante(v.featured_media.id)) sec.__dfGaleria.irA(0);
      }

      // === Availability check ===
      var addBtn = sec.querySelector('[data-df-add]');
      var stickyBtn = sec.querySelector('[data-df-pdp-stickycta-trigger]');
      if (v.available === false) {
        if (addBtn) {
          addBtn.disabled = true;
          var lbl = addBtn.querySelector('[data-df-cta-label]');
          if (lbl) lbl.textContent = 'Agotado';
        }
        if (stickyBtn) stickyBtn.disabled = true;
      } else {
        if (addBtn) addBtn.disabled = false;
        if (stickyBtn) stickyBtn.disabled = false;
      }

      // === Notify other listeners (cart drawer, sticky CTA price) ===
      try {
        document.dispatchEvent(new CustomEvent('df:variant:changed', { detail: v }));
      } catch (e) {}

      // === Update URL with variant_id (sin recargar) ===
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        try { window.history.replaceState({}, '', url.toString()); } catch (e) {}
      }
    }
    sec.querySelectorAll('[data-df-option]').forEach(function (r) {
      r.addEventListener('change', function (e) {
        updateSelectedVariant();
        // Update current value label
        var pos = r.getAttribute('data-option-position');
        if (pos) {
          // Sin el «(18x24)cm»: la medida ya está en la propia celda, y en la
          // etiqueta el paréntesis crudo cantaba mucho.
          var limpio = r.value.split('(')[0].trim();
          // «Marco negro» → «Negro»: la etiqueta ya dice «Marco», igual que
          // lo pinta el Liquid al cargar.
          var sinMarco = limpio.replace(/^marco\s+/i, '');
          if (sinMarco !== limpio && sinMarco) limpio = sinMarco.charAt(0).toUpperCase() + sinMarco.slice(1);
          var lbl = sec.querySelector('[data-df-option-current="' + pos + '"]');
          if (lbl) lbl.textContent = limpio;
          // Opción plegada: la línea dice lo elegido y el panel se cierra solo.
          // Dejarlo abierto tras elegir esconde el botón de comprar otra vez,
          // que es justo lo que el pliegue venía a arreglar.
          var foldLbl = sec.querySelector('[data-df-fold-current="' + pos + '"]');
          if (foldLbl) {
            foldLbl.textContent = limpio;
            var fold = foldLbl.closest('[data-df-option-fold]');
            if (fold) fold.open = false;
          }
        }
      });
    });

    // Dropdown style: select element changes
    sec.querySelectorAll('[data-df-option-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        // sync hidden radio if exists, otherwise update directly
        var name = sel.getAttribute('name');
        var radios = sec.querySelectorAll('input[type="radio"][name="' + name + '"]');
        if (radios.length) {
          radios.forEach(function (r) { r.checked = (r.value === sel.value); });
          var ev = new Event('change', { bubbles: true });
          radios.forEach(function (r) { if (r.checked) r.dispatchEvent(ev); });
        } else {
          updateSelectedVariant();
        }
      });
    });
    // Initial run to sync state if URL has ?variant=
    updateSelectedVariant();

    // === CONFIRMACIÓN DE AÑADIDO · con fecha y salida al checkout ===
    /*
     * Lo que vivía aquí era un toast que nunca llegó a verse, por dos
     * motivos a la vez: medía el carrito DESPUÉS de que el añadido ya
     * hubiera ocurrido —comparaba 1 contra 1, nunca veía la subida y se
     * rendía a los 6 s— y además `.df-cart-toast` no tenía una sola regla
     * de CSS en todo el tema, así que aunque hubiera saltado habría salido
     * como un div sin estilo debajo del pie.
     *
     * Quien añade de verdad es df-cart-enhance.js —el tema padre se aparta
     * en cuanto ve [data-df-add]— y avisa con 'df:cart:updated'. De ahí
     * cuelga esto. El botón ya enseña «✓ Añadido» durante 1,8 s; lo que
     * faltaba es lo que se pierde entre añadir y pagar: la fecha de
     * entrega y una salida.
     *
     * La fecha NO se recalcula: se copia de [data-df-delivery-eta], que ya
     * la tiene en pantalla. Dos cálculos serían dos versiones de la verdad,
     * y el cliente las ve en dos clics.
     */
    (function () {
      var form = sec.querySelector('.df-pdp__form');
      if (!form) return;

      var panel = null, tmr = null, pendiente = false;

      function pararReloj() { if (tmr) { clearTimeout(tmr); tmr = null; } }
      function armarReloj() { pararReloj(); tmr = setTimeout(cerrar, 9000); }

      function construir() {
        if (panel) return panel;
        panel = document.createElement('div');
        panel.className = 'df-added';
        panel.setAttribute('role', 'status');
        panel.setAttribute('aria-live', 'polite');
        panel.hidden = true;
        panel.innerHTML =
          '<button type="button" class="df-added__x" aria-label="Cerrar">' +
            '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
          '</button>' +
          '<p class="df-added__title"><span class="df-added__check" aria-hidden="true">✓</span>Añadido a la cesta</p>' +
          '<p class="df-added__eta" data-df-added-eta hidden></p>' +
          '<a href="/checkout" class="df-added__cta">Finalizar compra</a>' +
          '<button type="button" class="df-added__seguir">Seguir mirando</button>';
        document.body.appendChild(panel);
        panel.querySelector('.df-added__x').addEventListener('click', cerrar);
        panel.querySelector('.df-added__seguir').addEventListener('click', cerrar);
        /* Con el ratón encima o el foco dentro nadie quiere que se vaya a
           media lectura: el reloj se para y vuelve a empezar al salir. */
        panel.addEventListener('mouseenter', pararReloj);
        panel.addEventListener('focusin', pararReloj);
        panel.addEventListener('mouseleave', armarReloj);
        return panel;
      }

      function cerrar() {
        pararReloj();
        if (!panel) return;
        panel.classList.remove('is-open');
        // `hidden` con retardo para que se vea la salida. Si vuelven a
        // añadir antes de que acabe, abrir() cancela este mismo reloj.
        tmr = setTimeout(function () { panel.hidden = true; tmr = null; }, 260);
      }

      function abrir() {
        construir();
        pararReloj();
        var eta = document.querySelector('[data-df-delivery-eta]');
        var linea = panel.querySelector('[data-df-added-eta]');
        var txt = eta ? (eta.textContent || '').trim() : '';
        // El guión es el estado inicial de la caja de entrega: si aún no ha
        // calculado, mejor sin línea que con una fecha vacía.
        if (txt && txt !== '—') {
          linea.textContent = 'Recíbelo el ' + txt;
          linea.hidden = false;
        } else {
          linea.hidden = true;
        }
        panel.hidden = false;
        void panel.offsetWidth; // reflow: sin esto la transición no arranca
        panel.classList.add('is-open');
        armarReloj();
      }

      /* El añadido es asíncrono: se marca en el submit y se confirma con el
         evento. Así el panel no se abre por un cambio de carrito que no
         haya pedido este formulario. */
      form.addEventListener('submit', function () { pendiente = true; });
      document.addEventListener('df:cart:updated', function () {
        if (!pendiente) return;
        pendiente = false;
        abrir();
      });
      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && panel && !panel.hidden) cerrar();
      });
    })();

    // === STICKY MOBILE CTA · consciente del personalizador ===
    /*
     * Dos estados:
     *   'ready'   → no hay personalizador, o ya está configurado.
     *               Botón: «Añadir · 29,95€» → dispara el add-to-cart real.
     *   'pending' → hay personalizador y el producto aún NO está configurado.
     *               Botón: «Personalizar» → lleva al personalizador.
     *
     * Antes esta barra estaba oculta por CSS en cuanto aparecía el host del
     * personalizador, así que los productos personalizables —los que más
     * venden— se quedaban sin CTA persistente en una página de 29.000px.
     *
     * Cómo se sabe si está configurado, por orden de fiabilidad:
     *   1. window.dfPerso.isConfigured()  → contrato del personalizador propio
     *   2. evento 'df:perso:state' con { configured: bool }
     *   3. heurística: dentro del host hay un botón de añadir visible y activo
     * Los selectores son ajustes de bloque: si el embed cambia su marcado se
     * arregla desde el editor, no desde aquí.
     */
    var stickyCta = sec.querySelector('[data-df-pdp-stickycta]');
    var stickyCtaTrigger = sec.querySelector('[data-df-pdp-stickycta-trigger]');
    var originalCtaRow = sec.querySelector('[data-df-pdp-cta-row]');
    var stickyPriceEl = sec.querySelector('[data-df-stickycta-price]');
    var pdpPriceMain = sec.querySelector('[data-df-cta-price]');

    if (stickyCta && stickyCtaTrigger && originalCtaRow) {
      var HOST_SEL = stickyCta.getAttribute('data-df-perso-host') || '.dfp-personalizer';
      var ADD_SEL  = stickyCta.getAttribute('data-df-perso-add') || '[data-dfp-add]';
      var labelEl  = stickyCtaTrigger.querySelector('[data-df-stickycta-label]');
      var textAdd  = stickyCtaTrigger.getAttribute('data-df-cta-add-text') || 'Añadir';
      var textPer  = stickyCtaTrigger.getAttribute('data-df-cta-perso-text') || 'Personalizar';
      var externalConfigured = null;   // lo fija el evento df:perso:state

      function persoHost() {
        try { return sec.querySelector(HOST_SEL) || document.querySelector(HOST_SEL); }
        catch (e) { return null; }
      }

      /*
       * ¿Está el personalizador propio al mando de esta página?
       *
       * Se mira el host `.dfp-personalizer` y la marca que pone su embed en el
       * <body>. NO vale con "hay un personalizador": Teeinblue también lo es,
       * pero se monta inline y deja el CTA nativo vivo, así que ahí el sticky
       * debe añadir al carrito como en cualquier producto y dejar que Teeinblue
       * valide al enviar.
       */
      function persoTakesOver() {
        return !!persoHost() || document.body.hasAttribute('data-personalizer-active');
      }

      function nativeAddUsable() {
        var b = sec.querySelector('[data-df-add]');
        return !!b && isVisible(b) && !b.disabled;
      }

      function isVisible(el) {
        return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
      }

      function persoAddButton() {
        var host = persoHost();
        if (!host) return null;
        var btns;
        try { btns = host.querySelectorAll(ADD_SEL); } catch (e) { return null; }
        for (var i = 0; i < btns.length; i++) {
          if (!btns[i].disabled && isVisible(btns[i])) return btns[i];
        }
        return null;
      }

      function isConfigured() {
        if (window.dfPerso && typeof window.dfPerso.isConfigured === 'function') {
          try { return !!window.dfPerso.isConfigured(); } catch (e) {}
        }
        if (externalConfigured !== null) return externalConfigured;
        return !!persoAddButton();
      }

      function syncStickyState() {
        var state;
        if (!persoTakesOver()) {
          // Teeinblue o producto sin personalizar: comportamiento normal.
          state = 'ready';
        } else if (isConfigured()) {
          state = 'ready';
        } else if (!persoHost() && !nativeAddUsable()) {
          /*
           * El embed marcó la página como suya, escondió el CTA nativo y luego
           * no montó nada. Antes esto era fallar en cerrado y EN SILENCIO: la
           * página se quedaba sin forma de comprar y sin decirlo. El botón se
           * queda visible y deshabilitado, que es lo que manda el sistema de
           * diseño: nunca ocultar el botón.
           */
          state = 'broken';
        } else {
          state = 'pending';
        }

        if (stickyCta.getAttribute('data-df-perso-state') === state) return;
        stickyCta.setAttribute('data-df-perso-state', state);

        if (state === 'broken') {
          if (labelEl) labelEl.textContent = DFP_PT ? 'Não disponível neste momento' : 'No disponible ahora mismo';
          stickyCtaTrigger.disabled = true;
          stickyCtaTrigger.setAttribute('aria-label', 'El personalizador no ha cargado. Recarga la página o escríbenos.');
          return;
        }

        stickyCtaTrigger.disabled = false;
        if (labelEl) labelEl.textContent = (state === 'pending') ? textPer : textAdd;
        stickyCtaTrigger.setAttribute(
          'aria-label',
          (state === 'pending') ? textPer + ' este producto' : textAdd + ' al carrito'
        );
      }

      /* El canvas del personalizador muta constantemente: sin freno esto
         correría en cada frame de un arrastre del mapa. Una pasada por frame. */
      var syncQueued = false;
      function queueSync() {
        if (syncQueued) return;
        syncQueued = true;
        (window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (cb) { setTimeout(cb, 16); })(function () {
          syncQueued = false;
          syncStickyState();
        });
      }

      document.addEventListener('df:perso:state', function (e) {
        if (e.detail && typeof e.detail.configured === 'boolean') {
          externalConfigured = e.detail.configured;
        }
        queueSync();
      });
      document.addEventListener('teeinblue-event-component-injected', queueSync);

      syncStickyState();
      // El embed monta asíncrono y el estado cambia mientras el usuario
      // rellena: se revisa en cada mutación del contenedor de la ficha.
      if (typeof MutationObserver === 'function') {
        var persoMo = new MutationObserver(queueSync);
        persoMo.observe(sec, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled', 'style', 'hidden'] });
      }
      sec.addEventListener('change', queueSync);
      sec.addEventListener('input', queueSync);

      // Trigger sticky button
      stickyCtaTrigger.addEventListener('click', function () {
        var host = persoHost();
        var state = stickyCta.getAttribute('data-df-perso-state');

        if (state === 'pending' && host) {
          // Todavía no hay nada que añadir: llevar al personalizador.
          try { host.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          catch (e) { host.scrollIntoView(); }
          var focusable = host.querySelector('input, select, textarea, button, [tabindex]:not([tabindex="-1"])');
          if (focusable) setTimeout(function () { try { focusable.focus({ preventScroll: true }); } catch (e) {} }, 400);
          try { document.dispatchEvent(new CustomEvent('df:perso:focus', { detail: { origen: 'sticky' } })); } catch (e) {}
          return;
        }

        // Configurado (o producto sin personalizador): añadir de verdad.
        var persoAdd = persoAddButton();
        if (persoAdd) { persoAdd.click(); return; }

        var form = sec.querySelector('.df-pdp__form');
        var addBtn = sec.querySelector('[data-df-add]');
        if (addBtn && !addBtn.disabled) {
          addBtn.click();
        } else if (form) {
          form.requestSubmit ? form.requestSubmit() : form.submit();
        }
      });

      // La variante elegida también se refleja en el sticky (mock: "título · negro")
      document.addEventListener('df:variant:changed', function (e) {
        var vEl = stickyCta.querySelector('[data-df-stickycta-variant]');
        if (vEl && e.detail && e.detail.title) {
          vEl.textContent = String(e.detail.title).split(' / ')[0].toLowerCase();
        }
      });

      // Mirror price changes
      if (pdpPriceMain && stickyPriceEl) {
        var mo = new MutationObserver(function () {
          stickyPriceEl.textContent = pdpPriceMain.textContent;
          var ctaPrice = stickyCtaTrigger.querySelector('[data-df-stickycta-cta-price]');
          if (ctaPrice) ctaPrice.textContent = ' · ' + pdpPriceMain.textContent;
        });
        mo.observe(pdpPriceMain, { childList: true, characterData: true, subtree: true });
      }

      /*
       * Visible siempre que el CTA real NO esté en pantalla, esté por encima o
       * por debajo. En móvil hay que bajar ~2.600px para llegar al CTA, así que
       * si la barra sólo apareciera "al pasarlo de largo" no habría ningún CTA
       * en casi toda la página: justo el problema que viene a tapar.
       *
       * Con el CTA todavía por debajo se esperan 240px de scroll, para no
       * plantar una barra sobre la foto nada más cargar.
       *
       * OJO · esto NO puede ir en un IntersectionObserver. El observer sólo
       * avisa cuando el elemento CRUZA el borde del viewport, y bajando desde
       * arriba el CTA nunca lo cruza: está fuera de pantalla todo el rato. La
       * barra se quedaba oculta durante todo el tramo largo, que es justo donde
       * hace falta. Con scroll + rAF se reevalúa de verdad y cuesta lo mismo.
       */
      function updateStickyVisibility() {
        var r = originalCtaRow.getBoundingClientRect();
        var offscreen = r.bottom <= 0 || r.top >= window.innerHeight;
        var show = offscreen && (r.top < 0 || window.scrollY > 240);
        stickyCta.classList.toggle('is-visible', show);
        stickyCta.setAttribute('aria-hidden', show ? 'false' : 'true');
      }

      var visTicking = false;
      function onScrollSticky() {
        if (visTicking) return;
        visTicking = true;
        (window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (cb) { setTimeout(cb, 16); })(function () {
          visTicking = false;
          updateStickyVisibility();
        });
      }
      window.addEventListener('scroll', onScrollSticky, { passive: true });
      window.addEventListener('resize', onScrollSticky, { passive: true });
      updateStickyVisibility();
    }

    // === MOVIMIENTO (23-09) ================================================
    /*
     * Lo que hace la ficha más agradable sin estorbar. Todo con transform y
     * opacity (nada mueve el layout: CLS cero) y todo se apaga con
     * `prefers-reduced-motion`. Las curvas, sin rebote salvo el pop de los
     * corazones, que es la gracia.
     *
     * `df-motion.js` existe en assets pero no lo carga ninguna página: esto
     * es solo de la ficha y no depende de él.
     */
    (function () {
      var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (quieto) return;

      // ---- 1. Fotos que entran con fundido al llegar -----------------------
      // Solo las lazy que aún no han llegado. La primera foto (LCP) no se
      // toca nunca: esconderla aunque sea 300 ms es que la página tarde más.
      sec.querySelectorAll('.df-pdp__media-item img, .df-pdp__thumb img').forEach(function (img, k) {
        if (img.closest('.df-pdp__media-item') && img.closest('[data-df-media-index="0"]')) return;
        if (img.complete && img.naturalWidth) return;
        img.classList.add('df-pdp-fade');
        var ver = function () { img.classList.add('is-in'); };
        img.addEventListener('load', ver, { once: true });
        img.addEventListener('error', ver, { once: true });
        setTimeout(ver, 3000);
      });

      // ---- 2. Al añadir: corazones que salen del botón y la cesta salta ----
      var origen = null;
      sec.addEventListener('pointerdown', function (e) {
        var b = e.target.closest('button[type="submit"], [data-df-pdp-stickycta-trigger], [data-df-add]');
        if (b) origen = b;
      }, true);
      var formAdd = sec.querySelector('.df-pdp__form');
      var pedido = false;
      if (formAdd) formAdd.addEventListener('submit', function () { pedido = true; });

      function corazones(el) {
        var r = el && el.getBoundingClientRect();
        if (!r || !r.width || r.bottom < 0 || r.top > window.innerHeight) return;
        var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        var N = 7;
        for (var i = 0; i < N; i++) {
          var h = document.createElement('span');
          h.className = 'df-pdp-burst';
          h.setAttribute('aria-hidden', 'true');
          h.innerHTML = '<svg viewBox="0 0 24 24" width="100%" height="100%"><path fill="currentColor" d="M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.5A4 4 0 0 1 19 10c0 5.5-7 10-7 10Z"/></svg>';
          // En abanico hacia arriba, cada uno con su tamaño y su giro.
          var ang = (-150 + (120 / (N - 1)) * i) * Math.PI / 180;
          var dist = 56 + Math.random() * 34;
          h.style.left = cx + 'px';
          h.style.top = cy + 'px';
          h.style.setProperty('--dx', Math.round(Math.cos(ang) * dist) + 'px');
          h.style.setProperty('--dy', Math.round(Math.sin(ang) * dist - 18) + 'px');
          h.style.setProperty('--rot', Math.round(Math.random() * 40 - 20) + 'deg');
          h.style.setProperty('--s', (0.75 + Math.random() * 0.5).toFixed(2));
          h.style.animationDelay = (i * 28) + 'ms';
          document.body.appendChild(h);
          setTimeout(function (n) { return function () { n.remove(); }; }(h), 1300);
        }
      }
      function saltoCesta() {
        document.querySelectorAll('.df-header__cart').forEach(function (c) {
          c.classList.remove('df-pdp-bump');
          void c.offsetWidth;
          c.classList.add('df-pdp-bump');
        });
      }
      document.addEventListener('df:cart:updated', function () {
        if (!pedido) return;
        pedido = false;
        corazones(origen || sec.querySelector('[data-df-pdp-cta-row] button[type="submit"]'));
        saltoCesta();
      });

      // ---- 3. Lo de debajo de la ficha entra al llegar ---------------------
      // Reseñas, complementos, vídeos, preguntas, «también te puede encajar».
      // Cada bloque entra entero (título y contenido juntos): trocearlo en
      // veinte piezas es lo que hace que una página parezca nerviosa. Lo que
      // ya está en pantalla al arrancar no se esconde nunca.
      if (!('IntersectionObserver' in window)) return;
      var raiz = sec.closest('.shopify-section');
      var bloques = [];
      var sig = raiz && raiz.nextElementSibling;
      while (sig) {
        if (sig.classList.contains('shopify-section') && sig.offsetHeight > 0) {
          var caja = sig.querySelector('.df-container') || sig.firstElementChild;
          if (caja) Array.prototype.forEach.call(caja.children, function (k) {
            if (k.offsetHeight > 24) bloques.push(k);
          });
        }
        sig = sig.nextElementSibling;
      }
      var alto = window.innerHeight;
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.02 });
      bloques.forEach(function (b) {
        if (b.getBoundingClientRect().top < alto) return;
        b.classList.add('df-pdp-rv');
        io.observe(b);
      });
      // Red: si por lo que sea el observador no llega, al bajar se revisa a
      // mano. Un bloque invisible es mucho peor que uno sin animar.
      var barrido = 0;
      window.addEventListener('scroll', function () {
        if (barrido) return;
        barrido = setTimeout(function () {
          barrido = 0;
          sec.ownerDocument.querySelectorAll('.df-pdp-rv:not(.is-in)').forEach(function (b) {
            if (b.getBoundingClientRect().top < window.innerHeight * 0.96) b.classList.add('is-in');
          });
        }, 120);
      }, { passive: true });
    })();
    } /* end _initPDP */

    /* Dispara _initPDP tras el primer paint para no bloquear el render
       inicial del right column (precio, variantes, CTA).

       Con requestAnimationFrame a secas la ficha no arrancaba nunca si la
       pestaña estaba en segundo plano: el navegador no pinta, así que el
       callback no llega. Y abrir el producto en una pestaña nueva (cmd+clic
       desde la colección o desde Google) es de lo más normal, así que se
       quedaba «Recíbelo el —» hasta que el cliente miraba la pestaña. El
       setTimeout es la red: gane quien gane, se ejecuta una sola vez. */
    var _pdpArrancado = false;
    function _bootPDP() {
      if (_pdpArrancado) return;
      _pdpArrancado = true;
      _initPDP();
    }
    function _programarPDP() {
      if (window.requestAnimationFrame) window.requestAnimationFrame(_bootPDP);
      setTimeout(_bootPDP, 150);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', _programarPDP, { once: true });
    } else {
      _programarPDP();
    }
  })();
